import React from "react";
import "./commpage.css";
import { BiArrowBack } from "react-icons/bi";
import { motion } from "framer-motion";

const CommPage = ({ backToHome }) => {
  const commPageanimate = {
    hidden: {
      x: "100vw",
    },
    visible: {
      x: 0,
      transition: { duration: 0.5 },
    },
    exit: {
      x: "100vw",
      transition: { ease: "easeInOut" },
    },
  };

  const microsoftLink = () => {
    window.open("https://www.microsoftsupplier.com", "_blank");
  };
  const shieldCannon = () => {
    window.open("https://www.shieldcannon.com/", "_blank");
  };
  // const staalixtLink = () => {
  //   window.open("https://www.staalix.nl", "_blank");
  // };
  // const adobeLink = () => {
  //   window.open("https://www.adobesupplier.com", "_blank");
  // };
  // const autodeskLink = () => {
  //   window.open("https://www.autodesksupplier.com", "_blank");
  // };
  const deHaaren = () => {
    return
    window.open("https://www.autodesksupplier.com", "_blank");
  };

  return (
    <motion.div
      className="commpage container  d-flex align-items-center  justify-content-center px-0"
      variants={commPageanimate}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <BiArrowBack onClick={backToHome} className="back-arrow" size={40} />
      <div className="container pb-5 ">
      <div className="row align-items-center  justify-content-center"> 
          <div className="col-md-3 mb-0">
            <button
              onClick={microsoftLink}
              className="button  button--moema"
            >
              Microsoft Supplier
            </button>
          </div>
          {/* <div className="col-md-3 mb-0">
            <button
              onClick={staalixtLink}
              className="  button button--moema w-100"
            >
              Staalix
            </button>
          </div> */}
        </div> 
        {/* <div className="row justify-content-center"> */}
          {/* <div className="col-md-3 mb-0">
            <button
              onClick={adobeLink}
              className=" button button--moema w-100"
            >
              Adobe Supplier
            </button>
          </div> */}
          {/* <div className="col-md-3 mb-0">
            <button
              onClick={adobeLink}
              className=" button button--moema w-100"
            >
              Adobe Supplier
            </button>
          </div> */}
          {/* <div className="col-md-3 mb-0">
            <button
              onClick={autodeskLink}
              className="  button button--moema w-100"
            >
              Autodesk Supplier
            </button>
          </div> */}
        {/* </div> */}
        <div className="row justify-content-center">
          <div className="col-md-3 mb-0 mb-4 mb-md-0 ">
            <button
              onClick={shieldCannon}
              className=" button button--moema w-100"
            >
              Shield cannon
            </button>
          </div>
          {/* <div className="col-md-3 mb-0">
            <button
              onClick={deHaaren}
              className=" button button--moema w-100 position-relative"
              disabled = {true}
            >
               De Haaren
              <p className="mt-1 position-absolute bottom-0 coming-soon">Coming soon</p>
            </button>
          </div> */}
        </div>
      </div>
    </motion.div>
  );
};

export default CommPage;
